/**
 * Fixed Scroll Section
 * ------------------------------------------------------------------------------
 * Customized scrolling scene with fixed elements and scroll-based animations -- only
 * actively in use on the Wall Art page.
 *
 */
window.theme = window.theme || {};
theme.fixedScroll = (() => {
  const breakpoint = 996;
  const targetBlockSelector = ".js-fixed-scroll-target";
  const childSelector = ".js-fixed-scroll-child";
  const dotSelector = ".js-fixed-scroll-dot";
  const fixedContainerSelector = ".js-fixed-container";

  let observer = null;

  function resetAllStyles() {
    if ( document.querySelector(fixedContainerSelector)) {
      document.querySelector(fixedContainerSelector).style.removeProperty("height");
    }

    document.querySelectorAll(`${targetBlockSelector} ${childSelector}`).forEach((el, i) => {
      if (i !== 0) el.classList.remove("is-visible");
    });

    document.querySelectorAll(`${targetBlockSelector} ${dotSelector}`).forEach((el, i) => {
      if (i !== 0) el.classList.remove("slick-active");
    });
  }

  function setSceneHeight() {
    const container = document.querySelector(fixedContainerSelector);
    if (container) {
      container.style.height = `${window.innerHeight - 64}px`;
    }    
  }

  function initScene() {
    const targetBlock = document.querySelector(targetBlockSelector); // the scroll section
    const container = document.querySelector(fixedContainerSelector); // the fixed visual container inside it
    if (!targetBlock || !container) return;
  
    const children = Array.from(container.querySelectorAll(childSelector));
    const dots = Array.from(container.querySelectorAll(dotSelector));
    const numSteps = children.length;
  
    // Set scrollable height based on number of steps
    targetBlock.style.height = `${window.innerHeight * numSteps}px`;
  
    function onScroll() {
      const scrollY = window.scrollY;
      const targetTop = targetBlock.offsetTop;
      const targetHeight = targetBlock.offsetHeight;
      const windowHeight = window.innerHeight;
  
      // Only activate when within scroll range
      if (scrollY >= targetTop && scrollY < targetTop + targetHeight) {
        const scrollProgress = (scrollY - targetTop + (windowHeight / 2)) / targetHeight;
        const index = Math.min(numSteps - 1, Math.floor(scrollProgress * numSteps));
  
        children.forEach((el, i) => el.classList.toggle('is-visible', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('slick-active', i === index));
      }
    }
    onScroll(); // initialize
    // This is packaged for the wall art page alone so doesn't have access to custom.utils.debounce
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
    window.addEventListener('scroll', debounce(onScroll, 50));
  }

  function resetScene() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function initHandler() {
    resetScene();
    resetAllStyles();
    if (window.innerWidth >= breakpoint) {
      setSceneHeight();
      initScene();
    }
  }

  function init() {
    if (!document.querySelector(targetBlockSelector)) return;

    initHandler();
    window.addEventListener("resize", initHandler);
  }

  return {
    init,
  };
})();

document.addEventListener("DOMContentLoaded", () => {
    theme.fixedScroll.init();
});


// WEBPACK FOOTER //
// ./src/scripts/src/sections/fixed-scroll.js